<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('txmis.creditLevel.updateList')" name="first"></el-tab-pane>
      <el-tab-pane :label="$t('txmis.creditLevel.journal')" name="second"></el-tab-pane>
    </el-tabs>
    <table-page v-show="activeName == 'first'" ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <table-page v-show="activeName == 'second'" ref="childTable1"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData1"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>

    <el-dialog :title="$t('txmis.creditLevel.batchImport')" :visible.sync="exportsVisible" :before-close="closePop">
        <el-upload ref="upload"  drag
                   :limit=limitNum
                   :auto-upload="false"
                   accept=".xlsx"
                   :action="UploadUrl()"
                   :before-upload="beforeUploadFile"
                   :on-change="fileChange"
                   :on-exceed="exceedFile"
                   :on-success="handleSuccess"
                   :on-error="handleError"
                   :file-list="fileList">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">{{$t('txmis.creditLevel.uploadTip')}}<em>{{$t('txmis.creditLevel.uploadTip1')}}</em></div>
          <div class="el-upload__tip" slot="tip">{{$t('txmis.creditLevel.uploadTip2')}}</div>
        </el-upload>
        <br/>
      <a href="https://sc.tfejy.com/source/downModel/信用等级模板.xlsx" class="el-button el-button--success el-button--default is-plain">{{$t('txmis.creditLevel.downTemplate')}}</a>
        <el-button size="small" type="primary" @click="uploadFile">{{$t('txmis.creditLevel.uploadFile')}}</el-button>
    </el-dialog>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import UPDATE from '@/components/page/update.vue'
    import DataUtil from '@/views/mis/util/data'
    import download from '@/utils/download'
    import { getToken } from '@/utils/auth'
    import { getQueryString } from '@/utils/tools'
    let businessType = {"SMARTFX": "2", "CF": "1"};
    let user = {};
    //接口地址url的统一管理
    import URL from '@/views/newmis36/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import Qs from 'qs'
    import axios from 'axios'
    let levelList ={};
    for (var i = -4; i < 11; i++) {
        levelList[i]=i;
    }
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE
        },
        created(){
            user = DataUtil.base.user();
        },
        methods: {
            handleClick(tab, event) {
               this.activeName=tab.name;
            },
            checkbox(row){
                this.deleteIds = row.map(key => key.id).join(",");
            },
            /*表格按钮点击事件*/
            bthClick (clickName, row) {
                if (clickName == "update"){
                    this.$refs.childUpdate.open(row);
                }
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName || window.$t('txmis.bt.query') == clickName){
                    this.queryData = data;
                    if(this.activeName == 'first') this.$refs.childTable.defaultQueryData(data);
                    else this.$refs.childTable1.defaultQueryData(data);
                }else if(window.$t('txmis.bt.add') == clickName){
                    this.$refs.childUpdate.open();
                }else if(window.$t('txmis.bt.down') == clickName){
                    download.exportExcel(URL.creditLevel.download,data,window.$t('txmis.creditLevel.creditLevel'));
                }else if(window.$t('txmis.creditLevel.batchUpdate') == clickName){
                    this.exportsVisible = true;
                }
            },
            /*新增或跟提交数据触发事件*/
            submit(model){
                //根据是否包含id更新还是添加
                this.dataChanage(URL.creditLevel.addOrUpdate,model,res => {
                    if (res.code == 0){
                        this.$refs.childUpdate.close();
                        this.$message.success(window.$t('txmis.rewardDealList.confirmSuccess'));
                        this.$refs.childTable.defaultGetData(this.queryData);
                    }else{
                        this.$message.success(window.$t('txmis.rewardDealList.confirmFail'));
                    }
                })
            },
            dataChanage(url,option,suc,fail){
                this.$axios.post(url, Qs.stringify(option || {})).then(res => {
                    if(suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if(fail && (typeof fail == 'function')) fail(res);
                })
            },
            // 文件超出个数限制时的钩子
            exceedFile(files, fileList) {
                this.$message.warning(`只能选择 ${this.limitNum} 个文件，当前共选择了 ${files.length + fileList.length} 个`);
            },
            // 文件状态改变时的钩子
            fileChange(file, fileList) {
                this.fileList.push(file.raw) ;
            },
            // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
            beforeUploadFile(file) {
                let extension = file.name.substring(file.name.lastIndexOf('.')+1);
                let size = file.size / 1024 / 1024;
                if(extension !== 'xlsx') {
                    this.$message.warning('只能上传后缀是.xlsx的文件');
                }
                if(size > 10) {
                    this.$message.warning('文件大小不得超过10M');
                }
            },
            // 文件上传成功时的钩子
            handleSuccess(res, file, fileList) {
                this.$message.success('文件上传成功');
            },
            // 文件上传失败时的钩子
            handleError(err, file, fileList) {
                this.$message.error('文件上传失败');
            },
            UploadUrl:function(){
                // 因为action参数是必填项，我们使用二次确认进行文件上传时，直接填上传文件的url会因为没有参数导致api报404，所以这里将action设置为一个返回为空的方法就行，避免抛错
                return ""
            },
            uploadFile() {
                if (this.fileList.length === 0){
                    this.$message.warning('请上传文件');
                } else {
                    let form = new FormData();
                    let fileObj=this.fileList[0];
                    form.append('file', fileObj);
                    form.append(`name`, fileObj.name);
                    axios.post(URL.creditLevel.uploadTemplate,form,{
                        headers: {
                            'businessType': 'default',
                            'Content-Type': 'multipart/form-data',
                            'Authorization': getToken(getQueryString('label')),
                        },
                        timeout: 20000,
                    }).then(
                        res=>{
                            if(res.data.code==0){
                                this.$message.success(window.$t('txmis.creditLevel.uploadSuc'));
                                this.fileList=[];
                                this.$refs.childTable.defaultGetData(this.queryData);
                            }else{
                                this.$message.error(window.$t('txmis.creditLevel.uploadFail'));
                            }
                        },err =>{
                            this.$message.error(window.$t('txmis.creditLevel.uploadFail'));
                        });
                }
            }, /*关闭弹窗*/
            closePop() {
                this.exportsVisible = false;
                this.$refs.upload.clearFiles();
            }
        },
        data () {
            return {
                deleteIds:"",
                queryData:{},
                activeName: 'first',
                exportsVisible:false,
                limitNum: 1,  // 上传excell时，同时允许上传的最大数
                fileList: [],   // excel文件列表
                /*新增或更新*/
                updateData:{
                    cols:[
                        { title: window.$t('txmis.creditLevel.customerNo'), field: 'customerNo'},
                        { title: window.$t('txmis.creditLevel.creditLevel'), field: 'creditLevel',type:2,optionList:levelList,isNumber:true},
                        { title: window.$t('txmis.creditLevel.remark'), field: 'remark'},
                    ]
                },
                /*from查询表单*/
                formData:{
                    hasLable: true,
                    cols:[
                        { title: window.$t('txmis.creditLevel.customerNo'), field: 'customerNo'},
                        { title: window.$t('txmis.creditLevel.pkey'), field: 'pkey'},
                        { title: window.$t('txmis.creditLevel.creditLevelOld'), field: 'creditLevelOld'},
                        { title: window.$t('txmis.creditLevel.creditLevelOriginal'), field: 'creditLevel'},
                        { title: window.$t('txmis.common.startTime'), field: 'startTime',type:5,format:'yyyy-MM-dd HH:mm:ss'},
                        { title: window.$t('txmis.common.endTime'), field: 'endTime',type:5,format:'yyyy-MM-dd HH:mm:ss'},
                        {click: window.$t('txmis.bt.query')},
                        {click: window.$t('txmis.bt.down')},
                        {click: window.$t('txmis.bt.add')},
                        {click:window.$t('txmis.creditLevel.batchUpdate')}
                    ]
                },
                /*table生成*/
                pageData: {
                    queryUrl: URL.creditLevel.query, //请求路径和参数
                    selection: true,
                    sequence: true,
                    cols: [
                        { title: window.$t('txmis.creditLevel.customerNo'), field: 'customerNo'},
                        { title: window.$t('txmis.creditLevel.pkey'), field: 'pkey'},
                        { title: window.$t('txmis.creditLevel.creditLevelOld'), field: 'creditLevelOld'},
                        { title: window.$t('txmis.creditLevel.creditLevelOriginal'), field: 'creditLevel'},
                        { title: window.$t('txmis.creditLevel.createDate'), field: 'createDate'},
                        { title: window.$t('txmis.creditLevel.createUser'), field: 'createUser'},
                        { title: window.$t('txmis.creditLevel.updateUser'), field: 'updateUser'},
                        { title: window.$t('txmis.creditLevel.updateDate'), field: 'updateDate'},
                        { title: window.$t('txmis.creditLevel.remark'), field: 'remark'},
                        {field:window.$t('txmis.bt.edit'),title:window.$t('txmis.bt.operation'),size:"mini",click:"update",type:"primary",icon:"el-icon-update"}
                    ]
                },
                pageData1: {
                    queryUrl: URL.creditLevel.logQuery, //请求路径和参数
                    selection: true,
                    sequence: true,
                    cols: [
                        { title: window.$t('txmis.creditLevel.customerNo'), field: 'customerNo'},
                        { title: window.$t('txmis.creditLevel.pkey'), field: 'pkey'},
                        { title: window.$t('txmis.creditLevel.creditLevelOld'), field: 'creditLevelOld'},
                        { title: window.$t('txmis.creditLevel.creditLevelOriginal'), field: 'creditLevel'},
                        { title: window.$t('txmis.creditLevel.createDate'), field: 'createDate'},
                        { title: window.$t('txmis.creditLevel.createUser'), field: 'createUser'},
                        { title: window.$t('txmis.creditLevel.updateUser'), field: 'updateUser'},
                        { title: window.$t('txmis.creditLevel.updateDate'), field: 'updateDate'},
                        { title: window.$t('txmis.creditLevel.remark'), field: 'remark'},
                    ]
                }
            }
        }
    }
</script>
